<template>
  <v-menu
    data-testid="main-nav-app-switcher"
    v-model="menuOpen"
    offset-y
    :nudge-bottom="8"
    :close-on-content-click="true"
    content-class="main-nav-app-switcher__menu"
    transition="fade-transition"
  >
    <template #activator="{ on, attrs }">
      <v-tooltip bottom content-class="tooltip-bottom">
        <template #activator="{ on: ton, attrs: tattrs }">
          <button
            data-testid="main-nav-app-switcher__btn"
            type="button"
            class="main-nav-app-switcher__btn"
            :class="{ 'main-nav-app-switcher__btn--open': menuOpen }"
            v-bind="{ ...attrs, ...tattrs }"
            v-on="{ ...on, ...ton }"
            aria-label="Apps"
          >
            <img
              data-testid="main-nav-app-switcher__icon"
              src="/img/navicon/AppSwitcher.svg"
              alt=""
              class="main-nav-app-switcher__icon"
            />
          </button>
        </template>
        <span>Apps</span>
      </v-tooltip>
    </template>

    <v-card
      data-testid="main-nav-app-switcher__card"
      class="main-nav-app-switcher__card shadow-off"
      :class="{ 'main-nav-app-switcher__card--with-admin': showAdminConsole }"
    >
      <div
        data-testid="main-nav-app-switcher__header"
        class="main-nav-app-switcher__header"
      >
        Apps
      </div>

      <div
        data-testid="main-nav-app-switcher__list"
        class="main-nav-app-switcher__list"
      >
        <div
          v-for="(app, index) in orderedApplist"
          :key="app.name || app.displayname || index"
          :data-testid="`main-nav-app-switcher__row--${index}`"
          class="main-nav-app-switcher__row"
          :class="{ 'main-nav-app-switcher__row--active': isActive(app) }"
          role="button"
          tabindex="0"
          @click="onAppClick(app)"
          @keyup.enter="onAppClick(app)"
        >
          <img
            v-if="isActive(app)"
            data-testid="main-nav-app-switcher__check"
            src="/img/navicon/app-switcher-check.svg"
            alt=""
            class="main-nav-app-switcher__check"
            aria-hidden="true"
          />
          <span
            data-testid="main-nav-app-switcher__name"
            class="main-nav-app-switcher__name"
          >{{ displayName(app) }}</span>
        </div>

        <div
          v-if="!applist.length"
          data-testid="main-nav-app-switcher__empty"
          class="main-nav-app-switcher__empty"
        >
          No apps
        </div>
      </div>

      <div
        v-if="showAdminConsole"
        data-testid="main-nav-app-switcher__admin"
        class="main-nav-app-switcher__admin"
        role="button"
        tabindex="0"
        @click="onAppClick(adminApp)"
        @keyup.enter="onAppClick(adminApp)"
      >
        <img
          data-testid="main-nav-app-switcher__admin-icon"
          src="/img/navicon/app-switcher-platform-shield.svg"
          alt=""
          class="main-nav-app-switcher__admin-icon"
          aria-hidden="true"
        />
        <div class="main-nav-app-switcher__admin-content">
          <span
            data-testid="main-nav-app-switcher__admin-title"
            class="main-nav-app-switcher__admin-title"
          >Admin Console</span>
          <span
            data-testid="main-nav-app-switcher__admin-description"
            class="main-nav-app-switcher__admin-description"
          >User, Data config &amp; AI agent settings for this org</span>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { isAppActive, isAppSwitcherManagerUser } from './mainNavUtils';

export default {
  name: 'AppSwitcher',
  props: {
    applist: { type: Array, default: () => [] },
    selectedAppKey: { type: String, default: null }
  },
  emits: ['app-click'],
  data() {
    return {
      menuOpen: false
    };
  },
  computed: {
    showAdminConsole() {
      return isAppSwitcherManagerUser(this.$store)
        && this.$store.state.accrualsbotEnabled === true;
    },
    adminApp() {
      return {
        name: this.$constants?.PRODUCT_KEYS?.ADMIN || 'admin',
        displayname: 'Admin Console',
        link: '/platform/console/agent-settings'
      };
    },
    orderedApplist() {
      const list = [...(this.applist || [])];
      return list.sort((a, b) => {
        const aActive = this.isActive(a) ? 0 : 1;
        const bActive = this.isActive(b) ? 0 : 1;
        return aActive - bActive;
      });
    }
  },
  methods: {
    displayName(app) {
      return app?.displayname || app?.name || '';
    },
    isActive(app) {
      if (String(app?.link || '').includes('/platform/console')) {
        return (this.$route.path || '').startsWith('/platform/console');
      }
      return isAppActive(app, this.$route.path, this.selectedAppKey);
    },
    onAppClick(app) {
      if (!app || this.isActive(app)) {
        this.menuOpen = false;
        return;
      }
      this.menuOpen = false;
      this.$emit('app-click', app);
    }
  },
  beforeDestroy() {
    this.menuOpen = false;
  }
};
</script>

<style lang="scss">
@import './AppSwitcher.scss';
</style>
